module.exports = __webpack_public_path__ + "img/reserve.3e27a2c9.svg";